import { Condition } from './Condition';
import { cn } from '../helper/classNames';
import {
  Card,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from './card';
import type { ReactNode } from 'react';

interface Props {
  readonly title?: string;
  readonly text?: string;
  readonly titleTooltip?: ReactNode;
  readonly children: any;
}

export function WidgetWrapper(props: Props) {
  if (!props.children) return null;

  // TODO: Add primary and secondary button

  return (
    <Card className="h-full flex flex-col">
      <Condition condition={props.title}>
        <CardHeader className="overflow-visible">
          <div className="flex items-center gap-2">
            <CardTitle className="text-xl font-semibold leading-snug">
              {props.title}
            </CardTitle>
            {/* Info-Tooltip entfernt gemäss Design-Policy */}
          </div>
          <Condition condition={props.text}>
            <CardDescription>{props.text}</CardDescription>
          </Condition>
        </CardHeader>
      </Condition>
      <CardContent className={cn('flex-grow', props.title && 'pt-0')}>
        {props.children}
      </CardContent>
    </Card>
  );
}
